import { get } from 'lodash';

// mustache-like syntax {{varName}}
const stache = /\{\{([^}]+)\}\}/g;

const toString = val => (val == null ? '' : val.toString());

export const getFormattedMarkdownText = (template, replacements, syntax) => {
  const replaceFn = (match, prop) => toString(get(replacements, prop));
  return template.replace(syntax || stache, replaceFn);
};
